var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"mr-2",attrs:{"label":"","color":"#1e1e1e","dark":""}},[_c('user-avatar',{attrs:{"user":_vm.userProp,"size":28}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }